export default {
    'ERROR-POST-PROSPECT-ONGOING-STATUS': {
        'NO-HELPER-OR-PROSPECT-ID-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Un id est requis pour continuer.",
                en: 'id is required to continue.',
            },
        },
        'NO-RELATION-MOMENT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Action introuvable ou expirée.",
                en: 'Action not found or expired.',
            },
            redirectPath: '/',
        },
        'ONGOING-SHOULD-BE-NULL': {
            actionType: 'toast',
            message: {
                fr: "L'action est déjà en cours.",
                en: 'The action is already ongoing.',
            },
        },
        'NO-MOMENT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Moment lié introuvable.",
                en: 'Linked moment not found.',
            },
            redirectPath: '/',
        },
    },
    'ERROR-POST-PROSPECT-DONE-STATUS': {
        'NO-RELATION-MOMENT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Action introuvable ou expirée.",
                en: 'Action not found or expired.',
            },
            redirectPath: '/',
        },
        'NO-RELATION-OR-MOMENT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Impossible d'accéder à l'action.",
                en: 'Unable to access the action.',
            },
            redirectPath: '/',
        },
        'PROSPECT-ALREADY-VALIDATED': {
            actionType: 'toast',
            message: {
                fr: "Vous avez déjà validé cette action.",
                en: 'You already validated this action.',
            },
        },
        'MOMENT-SKIPPED': {
            actionType: 'toast',
            message: {
                fr: "Action sautée, plus de validation possible.",
                en: 'Action skipped, cannot validate anymore.',
            },
        },
        'WEIRD-VALIDATION-RULES-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Erreur inattendue dans les validations.",
                en: 'Unexpected error during validations.',
            },
        },
        'WEIRD-NO-MOMENT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Moment introuvable après validation.",
                en: 'Moment not found after validation.',
            },
            redirectPath: '/',
        },
    },
    'ERROR-POST-PROSPECT-READ': {
        'NO-RELATION-MOMENT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Action introuvable ou expirée.",
                en: 'Action not found or expired.',
            },
            redirectPath: '/',
        },
        'NO-MOMENT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Moment lié introuvable.",
                en: 'Linked moment not found.',
            },
            redirectPath: '/',
        },
    },
};
